import { Typography } from 'antd';
import type { TFunction } from 'i18next';

import type { AddressValidationSuggestion } from '../api/addressValidation';
import type { ClientFormValues } from '../models/Forms';
import { isStateEquivalent, normalizePostalCode } from './applyAddressValidation';

export function AddressSuggestionModalContent({
  suggestion,
  values,
  t,
  introKey = 'clientForm.addressValidation.suggestIntro',
}: {
  suggestion: AddressValidationSuggestion;
  values: ClientFormValues;
  t: TFunction;
  introKey?: 'clientForm.addressValidation.suggestIntro' | 'clientForm.addressValidation.reviewIntro';
}) {
  const pscChanged = suggestion.psc && normalizePostalCode(suggestion.psc) !== normalizePostalCode(values.psc ?? '');
  const stateChanged = Boolean(suggestion.state && !isStateEquivalent(suggestion.state, values.state));

  return (
    <>
      <Typography.Paragraph>{t(introKey)}</Typography.Paragraph>
      {suggestion.formattedPreview ? (
        <Typography.Paragraph strong>{suggestion.formattedPreview}</Typography.Paragraph>
      ) : null}
      {pscChanged ? (
        <Typography.Paragraph>
          {t('clientForm.addressValidation.suggestPscValue', { value: suggestion.psc })}
        </Typography.Paragraph>
      ) : null}
      {stateChanged ? (
        <Typography.Paragraph>
          {t('clientForm.addressValidation.suggestStateValue', { value: suggestion.state })}
        </Typography.Paragraph>
      ) : null}
    </>
  );
}
